import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4">
      <h1 className="text-8xl md:text-[10rem] font-heading font-bold text-background-300 select-none">
        404
      </h1>
      <div className="relative z-10 -mt-8">
        <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-2">
          Strona nie została znaleziona
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-md mx-auto">
          Przepraszamy, ale strona której szukasz nie istnieje lub została przeniesiona.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-200 cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          Powrót do strony głównej
        </Link>
      </div>
    </div>
  );
}